import { css } from '@emotion/react';

export const circle = css`
  border-radius: 50%;
`;
